/* eslint-disable */
export default {
  Inbound: 'Inbound',
  Outbound: 'Outbound',
  log: 'Log',
  save: 'Save and new',
  discard: 'Discard and new',
  hangup: 'Hang up',
  reject: 'To voicemail',
  saveDraftAndCreateNewLog: 'Save draft and create new call log',
} as const;

// @key: @#@"Inbound"@#@ @source: @#@"Inbound"@#@
// @key: @#@"Outbound"@#@ @source: @#@"Outbound"@#@
// @key: @#@"log"@#@ @source: @#@"Log"@#@
// @key: @#@"save"@#@ @source: @#@"Save and new"@#@
// @key: @#@"discard"@#@ @source: @#@"Discard and new"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hangup"@#@
// @key: @#@"reject"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"saveDraftAndCreateNewLog"@#@ @source: @#@"Save draft and create new call log"@#@
